// extracted by mini-css-extract-plugin
module.exports = {"lia-checkbox":"RegistrationForm_lia-checkbox__RiJn_"};